import _uniq from "lodash/uniq";
import _pick from "lodash/pick";
import { metricsInterfaces } from 'app/stores/metrics/metricsInterfaces';
import api from 'core/util/api';
import $exports from 'app/stores/$exports';
const includedColumnsComponents = ['device_name', 'index', 'name', 'description', 'parent', 'parent-position', 'removable', 'type', 'hardware-version', 'mfg-name', 'model', 'original-state', 'original-type', 'serial-no', 'oper-status', 'firmware-version', 'software-version'];
const includedColumnsBgpNeighbors = ['id', 'device_id', 'device_name', 'index', 'enabled', 'local-as', 'transport/remote-address', 'transport/remote-port', 'peer-as', 'prefix-table-index', 'network-instance', 'session-state', 'timers/hold-time', 'timers/keepalive-interval', 'timers/connect-retry', 'transport/local-address', 'transport/local-port', 'last_status_update'];
export const exportFileName = name => {
  const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  return `nms-${name.trim()}-${date}`;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const exportCsv = (data, options) => {
  const {
    includedColumns,
    name,
    valueMap
  } = options;
  const exportData = data.map(fullDatum => {
    const datum = includedColumns ? _pick(fullDatum, includedColumns) : {
      ...fullDatum
    };
    Object.entries(datum).forEach(([key, value]) => {
      const valueFunc = valueMap?.[key];
      if (valueFunc) {
        datum[key] = valueFunc(value);
      }
    });
    return datum;
  });
  $exports.exportCsv({
    fileName: exportFileName(name),
    data: exportData
  });
};
export const exportRemoteCsv = (data, options) => {
  const {
    name,
    type
  } = options;
  const path = `/api/ui/recon/${type}/csv`;
  const exportOptions = {
    path,
    fileName: exportFileName(name || type),
    type: 'csv'
  };
  $exports.addLoadingExport(exportOptions);
  return api.post(path, {
    data,
    rawResponse: true
  }).then(response => {
    $exports.clearLoadingExport(exportOptions);
    $exports.addPayload(response.text, exportOptions);
  });
};
export const exportQueryResultsCollectionToCsv = (resultCollection, query, fileName) => {
  let columns = query?.kmetrics?.dimensions || [];
  const metricColumns = Object.keys(query?.kmetrics?.rollups || {});
  columns = columns.concat(metricColumns);
  $exports.exportCsv({
    fileName: exportFileName(fileName),
    columns,
    data: resultCollection.toJS()
  });
};
export const exportAllInterfacesCsv = () => {
  const {
    data
  } = metricsInterfaces.getFetchOptions();
  exportRemoteCsv(data, {
    type: 'interfaces'
  });
};
export const exportInterfacesForDeviceCsv = deviceModel => {
  const {
    data
  } = deviceModel.interfaces.getFetchOptions();
  exportRemoteCsv(data, {
    name: `interfaces-${deviceModel.get('name')}`,
    type: 'interfaces'
  });
};
export const exportComponentsForDeviceCsv = deviceModel => {
  const data = deviceModel.components.toJS();
  exportCsv(data, {
    name: `components-${deviceModel.get('name')}`,
    includedColumns: includedColumnsComponents
  });
};
export const exportBgpNeighborsForDeviceCsv = deviceModel => {
  const data = deviceModel.neighbors.toJS();
  exportCsv(data, {
    name: `bgp-neighbors-${deviceModel.get('name')}`,
    includedColumns: includedColumnsBgpNeighbors
  });
};
export const exportQueryResultsCollectionTimeseriesToCsv = (resultCollection, query, fileName) => {
  const timestamp = 'timestampMillis';
  const columns = [timestamp];
  const timeMap = {};
  const dimensions = query?.kmetrics?.dimensions || [];

  // Group each series by the common timestamp
  resultCollection.models.forEach(model => {
    const dimsum = [];
    dimensions.forEach(dimension => {
      const value = model.get(dimension);
      dimsum.push(value);
    });
    const timeseries = model.get('timeseries');
    if (timeseries?.length > 0) {
      timeseries.forEach(ts => {
        const [timestampMillis, ...metrics] = ts;
        metrics.forEach((metric, idx) => {
          const seriesName = dimsum.concat([model.get('metrics')[idx]]).join(',');
          const seriesValue = metric;
          if (!timeMap[timestampMillis]) {
            timeMap[timestampMillis] = {};
          }
          timeMap[timestampMillis][seriesName] = seriesValue;
        });
      });
    }
  });

  // Join timeMap into rows for .csv
  const data = Object.entries(timeMap).map(([time, values]) => {
    values.timestampMillis = Number(time);
    return values;
  });
  $exports.exportCsv({
    fileName: exportFileName(fileName),
    columns: _uniq(columns.concat(Object.keys(data.at(0) || []))),
    data
  });
};